module.exports = __webpack_public_path__ + "img/transparent-nav-right-mitsu.2106a2b2.png";